<template>
  <div
    class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white dark:bg-gray-900 dark:border-gray-900 px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-8"
  >
    <!-- Remove justify-end when global search from is uncommented -->
    <div class="flex flex-1 justify-end gap-x-4 self-stretch lg:gap-x-6">
      <!-- <form class="grid flex-1 grid-cols-1" action="#" method="GET">
                <input type="search" name="search" aria-label="Search" class="col-start-1 row-start-1 block size-full pl-8 text-bas outline-hidden sm:text-sm/6 bg-white text-gray-900 placeholder:text-gray-400 dark:bg-gray-900 dark:text-white" placeholder="Search" />
                <PhMagnifyingGlass class="pointer-events-none col-start-1 row-start-1 size-5 self-center text-gray-400" :size="24" aria-hidden="true" />
            </form> -->
      <div class="flex items-center gap-x-4 lg:gap-x-6">
        <Menu as="div" class="relative">
          <MenuButton class="-m-1.5 flex items-center p-1.5">
            <span class="sr-only">Open user menu</span>
            <span class="flex lg:items-center">
              <span
                class="ml-4 text-sm/6 font-semibold text-gray-900 dark:text-white"
                aria-hidden="true"
              >
                {{ userName }}
              </span>
              <PhCaretDown
                class="ml-2 size-5 text-gray-400"
                :size="24"
                aria-hidden="true"
              />
            </span>
          </MenuButton>
          <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
          >
            <MenuItems
              class="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md py-2 ring-1 shadow-lg bg-white ring-gray-900/5 focus:outline-hidden dark:bg-gray-800 dark:ring-gray-900 dark:ring-opacity-50 dark:text-white"
            >
              <MenuItem
                v-for="item in userNavigation"
                :key="item.name"
                v-slot="{ active }"
              >
                <a
                  :href="item.href"
                  :class="[
                    active
                      ? 'bg-gray-50 dark:bg-gray-900 dark:text-white outline-hidden'
                      : '',
                    'block px-3 py-1 text-sm/6 text-gray-900 dark:bg-gray-800 dark:text-white',
                  ]"
                >
                  {{ item.name }}
                </a>
              </MenuItem>
            </MenuItems>
          </transition>
        </Menu>
      </div>
    </div>
  </div>
</template>

<script setup>
import { PhCaretDown } from "@phosphor-icons/vue";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";

const props = defineProps({
  userName: {
    type: String,
    default: null,
  },
});
const userNavigation = [{ name: "Log Out", href: route("auth.logout") }];
</script>
